import React from 'react';
import {TranslationContext} from "../translations/context";

const ResourceSelect = (props) => {
    const {location, selectedResource, handleSelectedResourceUpdate} = props;
    const {t} = React.useContext(TranslationContext);

    return <select
        value={(selectedResource) ? selectedResource.id : ''}
        onChange={handleSelectedResourceUpdate}
    >
        <option key="resource-0" value={0}>{t('please_choose')}</option>
        {location.resources.filter(resource => resource.status === 'free').map(resource =>
            <option key={`resource-${resource.id}`} value={resource.id}>
                {resource.identifier}
            </option>,
        )}
    </select>
};

export default ResourceSelect;
